module.exports = __webpack_public_path__ + "assets/img/cv-bg-1034192a.png";